var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"main"},[_c('h1',{staticClass:"intro"},[_vm._t("heading")],2),(_vm.loading)?_c('loader'):_c('div',{staticClass:"row"},[_c('div',{staticClass:"row__col_grow"},[_vm._t("default")],2),(_vm.$slots.sidebar)?_c('div',{staticClass:"desc"},[_vm._t("sidebar")],2):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }